import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-run-confirm-dialog',
    templateUrl: './run-confirm-dialog.component.html',
    styleUrls: ['./run-confirm-dialog.component.css'],
    standalone: false
})
export class RunConfirmDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<RunConfirmDialogComponent>) { }

  ngOnInit(): void {
  }

}
